document.addEventListener('DOMContentLoaded', function() {
  function resizeCardsHover() {
    const rootStyles = getComputedStyle(document.documentElement);
    const mainWidth = rootStyles.getPropertyValue('--lg');
    const width = document.documentElement.clientWidth;
    const itemAll = document.querySelectorAll('._js-cards-hover');
    if (itemAll.length) {
      if (width <= mainWidth) {
        itemAll.forEach(el => {
          el.addEventListener('click', () => {
            if (el.classList.contains('_active')) {
              el.classList.remove('_active');
            } else {
              itemAll.forEach(elem => elem.classList.remove('_active'));
              el.classList.add('_active');
            }
          })
        })
      }
    }
  }

  window.addEventListener("resize", resizeCardsHover);
  resizeCardsHover();
});